export async function simulateEVMTransactionsClient({
  network,
  transactions
}) {
  try {
    const response = await fetch('/api/evm/simulate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        network,
        transactions
      })
    });
    return response.json();
  } catch (err) {
    console.error('[simulateEVMTransactionsClient]', err);
    return {
      status: 'error',
      simsPassed: false,
      simulationResults: [],
      error: err.message || 'Unknown error occurred during sim'
    };
  }
}